import React from 'react';
import { cn } from '@/lib/utils';

interface ThreeDotsLoaderProps {
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export const ThreeDotsLoader: React.FC<ThreeDotsLoaderProps> = ({
  size = 'sm',
  className,
}) => {
  const dotSizes = {
    xs: 'h-1 w-1',      // 4px - very small
    sm: 'h-1.5 w-1.5',  // 6px - small
    md: 'h-2 w-2',       // 8px - medium
  };

  return (
    <div className={cn('flex items-center space-x-0.5', className)}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className={cn(
            'rounded-full bg-muted-foreground animate-pulse',
            dotSizes[size]
          )}
          style={{
            animationDelay: `${i * 0.15}s`,
            animationDuration: '0.8s',
          }}
        />
      ))}
    </div>
  );
};

// Typing indicator component
export const TypingIndicator: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn('flex items-center space-x-2', className)}>
    <span className="text-sm text-muted-foreground">Thinking</span>
    <ThreeDotsLoader size="xs" />
  </div>
);